import styled from '@emotion/styled'

import { SECURITY_TYPES_TEXT } from '../../../../constants'
import { placeholderSymbolReplace } from '../../../../utils'
import { isGenericSecurity } from '../investmentUtils'

const Line = styled.div`
  font-size: 18px;
  line-height: 24px;
  color: ${p => p.theme.greyTextColor};
  margin-top: 13px;
`

/**
 * The investment name. It is capped at two lines so a long name can never grow the row it sits in,
 * and stays clear of anything pinned to the top right corner.
 */
const Name = styled(Line)`
  font-weight: 700;
  padding-right: ${p => p.clearsIcon && '40px'};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

/**
 * A chosen investment: name, ticker and type, in that order.
 *
 * The ticker of one of our internal generic proxies is an internal code that means nothing to the
 * user, so it is left out.
 */
const SecurityDetails = props => {
  const { security, clearsIcon = false } = props
  const { id, securityName, securityType, ticker } = security

  return (
    <div>
      <Name clearsIcon={clearsIcon} title={placeholderSymbolReplace(securityName)}>
        {placeholderSymbolReplace(securityName)}
      </Name>
      {ticker && !isGenericSecurity(id) && <Line>{placeholderSymbolReplace(ticker)}</Line>}
      <Line>{SECURITY_TYPES_TEXT[securityType]}</Line>
    </div>
  )
}

export default SecurityDetails
